import { render } from "./comp.skills.vue?vue&type=template&id=215f6082"
import script from "./comp.skills.vue?vue&type=script&lang=js"
export * from "./comp.skills.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__